import React, { useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import AccurityButton from '../../buttons/components/AccurityButton';
import Stack from '@mui/material/Stack';
export default function DataCatalogSyncLoadingDialog(_a) {
    var handleClose = _a.handleClose, _b = _a.title, title = _b === void 0 ? 'Loading' : _b;
    var onClose = useCallback(function (event, reason) {
        if ('backdropClick' === reason) {
            return;
        }
        handleClose();
    }, [handleClose]);
    return (React.createElement(Dialog, { className: "dataCatalogSyncDialog__narrow", fullWidth: true, open: true, onClose: onClose },
        React.createElement(DialogTitle, { className: "dataCatalogSyncDialog__centeredContent" },
            React.createElement(Stack, { direction: "column", alignItems: "center" },
                title,
                React.createElement(CircularProgress, { sx: { marginTop: '16px' } }))),
        React.createElement(DialogActions, null,
            React.createElement(AccurityButton, { onClick: handleClose }, "CANCEL"),
            React.createElement(AccurityButton, { disabled: true }, "CONFIRM"))));
}
//# sourceMappingURL=DataCatalogSyncLoadingDialog.js.map